import template from './template.html'

angular.module('contabilidad.polizas')
  .config(['$stateProvider', Config])

function Config ($stateProvider) {
  $stateProvider.state('contabilidad.polizas.provisionNomina', {
    url: '/provisionNomina?{fecha_inicio:date}&{fecha_fin:date}&:idOperadora&:ids_empresas&:ids_nominas',
    template,
    data: {
      title: 'Provisión Nomina',
    },
    params: {
      ids_empresas: {
        array: true,
      },
      ids_nominas: {
        array: true,
      },
    },
    resolve: {
      nominas: ['ContabilidadPolizas', '$stateParams', function (ContabilidadPolizas, $stateParams) {
        var fecha_inicio = $stateParams.fecha_inicio,
          fecha_fin = $stateParams.fecha_fin,
          ids_empresas = $stateParams.ids_empresas,
          id_operadora = $stateParams.idOperadora,
          nominasSeleccionadas = $stateParams.ids_nominas || []

        return fecha_inicio && fecha_fin && ids_empresas ? ContabilidadPolizas.traerNominas(
          fecha_inicio,
          fecha_fin,
          id_operadora,
          ids_empresas,
        ).then(function (nominas) {
          return nominas.map(function (item) {
            item.seleccionado = nominasSeleccionadas.indexOf(item.ID_Nomina) >= 0
            return item
          })
        }) : undefined
      }],

      polizas: ['provisionNominaService', '$stateParams', function (provisionNominaService, $stateParams) {
        var fecha_inicio = $stateParams.fecha_inicio,
          fecha_fin = $stateParams.fecha_fin,
          ids_empresas = $stateParams.ids_empresas,
          ids_nominas = $stateParams.ids_nominas

        return fecha_inicio && fecha_fin && ids_empresas && ids_nominas ? provisionNominaService.obtenerInformacionProvisionNomina(
          fecha_inicio,
          ids_nominas,
        ) : undefined
      }],

    },
    controllerAs: '$ctrl',
    controller: Controller,
  })
}

Controller.$inject = ['polizas', 'nominas', '$dialog', '$stateParams', '$location']

function Controller (polizas, nominas, $dialog, $stateParams, $location) {
  var $ctrl = this

  $ctrl.data = polizas
  if (polizas) {
    $ctrl.data.map(function (item) {
      if (item.Provision < 0) {
        item.Deudor = item.Deudor + item.Provision
        item.Provision = 0
      }
    })
  }
  $ctrl.nominas = nominas

  $ctrl.traerNominas = traerNominas
  $ctrl.obtenerInformacionPovisionNomina = obtenerInformacionProvisionNomina
  $ctrl.exportar = exportar
  $ctrl.actualizarEmpresas = actualizarEmpresas

  $ctrl.opciones = {
    fecha_inicio: $stateParams.fecha_inicio || new Date(),
    fecha_fin: $stateParams.fecha_fin || new Date(),
    ids_empresas: $stateParams.ids_empresas || [],
    id_operadora: $stateParams.idOperadora || null,
    ids_nominas: $stateParams.ids_nominas || [],
  }

  function traerNominas () {
    $location.search({
      fecha_inicio: $ctrl.opciones.fecha_inicio.toYMD(),
      fecha_fin: $ctrl.opciones.fecha_fin.toYMD(),
      idOperadora: $ctrl.opciones.id_operadora,
      ids_empresas: $ctrl.opciones.ids_empresas,
    })
  }

  function actualizarEmpresas (data) {
    $ctrl.opciones.ids_empresas = data.ids_empresas
    $ctrl.opciones.id_operadora = data.idOperadora
  }

  function obtenerInformacionProvisionNomina () {
    $location.search({
      fecha_inicio: $ctrl.opciones.fecha_inicio.toYMD(),
      fecha_fin: $ctrl.opciones.fecha_fin.toYMD(),
      ids_empresas: $ctrl.opciones.ids_empresas,
      idOperadora: $ctrl.opciones.id_operadora,
      ids_nominas: $ctrl.opciones.ids_nominas,
    })
  }

  function exportar () {
    $dialog.show('contabilidad.polizas.exportar', {
      data: $ctrl.data,
      fecha_inicio: $ctrl.opciones.fecha_inicio,
      // Se agregó ésta propiedad para indicar qué es lo que se va a exportar
      config: {
        fecha_inicio: $ctrl.opciones.fecha_inicio,
        fecha_fin: $ctrl.opciones.fecha_fin,
        nominas: $ctrl.nominas.filter(function (item) {
          return item.seleccionado
        }),
        archivo: ' Provision Nomina ',
        tipo_poliza: 'provisionNomina',
      },
    })
  }

}




// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/provisionnomina/component.js